// extracted by mini-css-extract-plugin
export default {"subheader":"subheader---Y3Ke1"};